import React from "react";
import AppBar from "../Landing/AppBar";
import JoinUs from "../Landing/JoinUs";
import About from "./About";

function PresentationPricing() {
  return (
    <React.Fragment>
      <AppBar />
      <About />
      <JoinUs />
    </React.Fragment>
  );
}

export default PresentationPricing;
